import classNames from "classnames/bind";
import UIIcon from "common/blocks/UIIcon";
import type { ResolvedTimelineItem } from "resolvers/data/timelineResolver";
import dayjs from "utils/dayjs";
import styles from "./TImeline.module.scss";

const cx = classNames.bind(styles);

export type TimelineProps = {
    timeline: ResolvedTimelineItem[];
};

const Timeline = ({ timeline }: TimelineProps) => (
    <div className={cx("timeline")}>
        <h2 className={cx("timelineTitle")}>Timeline</h2>
        <div className={cx("timelineList")}>
            {timeline.map(({ date, id, title }) => (
                <div className={cx("timelineListItem")} key={id}>
                    <div className={cx("timelineListItemIconWrapper")}>
                        <UIIcon className={cx("timelineListItemIcon")} icon="Timeline" />
                    </div>
                    <div className={cx("timelineListItemContent")}>
                        <span className={cx("timelineListItemDate")}>
                            {dayjs(date).format("MMM YYYY")}
                        </span>
                        <span className={cx("timelineListItemTitle")}>{title}</span>
                    </div>
                </div>
            ))}
        </div>
    </div>
);

export default Timeline;
